import React from 'react';
import {Button } from '@progress/kendo-react-buttons';
import Deltalhes from './Deltalhes';
import DadosEntidade from './DadosEntidade';
import services from '../../../../services';
class AffixingPopUp extends React.Component{
    constructor(props){
        super(props);
        this.state={
            dadosDetail:{},
            tab:"detalhes",
            tabDetail: "",
            entityDetail: {
                telephone: '',
                email: '',
                fax: ''
            },
            estatutosRes:[],
        }
    }
    componentDidMount(){
        let {tab}= this.state;
        this.showTabDetails(tab);
        this.estatutosApi();
        // console.log("tthheee roowwwwwwwwwww",this.props.row)
        this.getEntityDetails(this.props.row['idEntidadeAplicacao']);
        this.getDadosEntidadeDeatils();
    }
    estatutosApi= async ()=>{
        let Request = this.filterResponse();
        let link = "Sales/GetEstatutoListByEntityId"
        let estatutosRes = await services.apiCall.requestApi(link,Request);

        this.setState({
            estatutosRes,
        })
       
    }

    filterResponse=()=>{
        let Request={
            "Filters": null,
            "SortBy": "",
            "IsSortTypeDESC": true,
            "IsPagination": true,
            "Page": 1,
            "PageSize": 10,
        }
        let {idEntidadeAplicacao} = this.props.row;
        Request["entityId"]=idEntidadeAplicacao;

        return Request;
    }
    getEntityDetails = async (entity_id)=>{
        try {
        let request={};
        request.entityId = parseInt(entity_id);
        let entityDetail={}
        let link="/Revenue/GetEntityDetail";
        let entityDetailResponse= await services.apiCall.requestApi(link,request);
        if(entityDetailResponse){
            // console.log("xxxxxxxxxxxxxxxxyyyyy",entityDetailResponse);
            entityDetailResponse['v_CC_Entidade_Contact'].map(el=>{
                switch(el.codTipoContacto2){
                    case "TLM":
                        entityDetail.telephone=el.contacto;
                        break;
                    case "EMAIL":
                        entityDetail.email=el.contacto;
                        break;
                    default:
                        break;
                }
            });
        }
        this.setState({
            entityDetail
        })
    }catch(err){
        this.setState({
            err
        })
    }
    }
    updateTab=(tab)=>{
        this.setState({
            tab,
        },()=>{
            this.showTabDetails(this.state.tab)
        })
    }
    showTabDetails=(tab)=>{
        let {tabDetail}= this.state;
        if(tab==="detalhes"){
            tabDetail=(<Deltalhes row={this.props.row}/>);
        }
       else if(tab==="dadosEntidade"){
            tabDetail=(<DadosEntidade row={this.props.row} entityDetail={this.state.entityDetail} dadosDetail={this.state.dadosDetail} estatutosRes={this.state.estatutosRes}/>);
        }
        this.setState(
            {
                tabDetail,
            }
        )
    }

    getDadosEntidadeDeatils = () => {
        let data = {}
        let link = "Sales/GetDadosEntidadeDetail"
        let dadosDetail 
        let date = new Date(this.props.row['dataCriado'])
        console.log("the date ", date)
        data["entityId"] = this.props.row['idEntidadeAplicacao']
        data["year"] = date.getFullYear()
        console.log("the data I am sending is ", data)
        services.apiCall.requestApi(link, data, "post")
            .then(res => {
                console.log("response is.... ", res)
                dadosDetail = res
                this.setState({
                    dadosDetail
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    render(){
        return(
            <>
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" >
                        <strong>
                         Detalhe do pedido
                         </strong>
                    </span>
                    <Button primary={true} className="remove btn-ivdp-secondary cursor-pointer mr-2" data-dismiss="modal">Fechar</Button>
                </div>
                <div className="modal-body ">
                <div className="right-tab">
                <ul className="nav nav-tabs d-flex text-center">
                    <li className="nav-item flex-fill">
                        <strong><a className={`nav-link selos-nav right-tab ${this.state.tab=='detalhes'?`active`:""}`}  onClick={() => this.updateTab('detalhes')} data-toggle="tab" href="#Detalhes">Detalhes</a></strong>
                    </li>
                    <li className="nav-item flex-fill">
                        <strong><a className={`nav-link selos-nav ${this.state.tab=='dadosEntidade'?`active`:""}`}  onClick={() => this.updateTab('dadosEntidade')} data-toggle="tab" href="#Dados entidade">Dados entidade</a></strong>
                    </li>
                </ul>
                </div>
                {
                    this.state.tabDetail
                }
                </div>
            </div>
            </>
        )
    }
}

export default AffixingPopUp;